import { errors } from "@fraction/shared";

export function recreateErrorObject(error: any) {
  if (error?.response?.body?.message && error?.response?.body?.name) {
    // @ts-expect-error - error name keyed lookup
    if (errors[error?.response?.body?.name]) {
      // @ts-expect-error - error name keyed lookup
      return new errors[error.response.body.name](error.response.body.message);
    }
  }
  // A plain backend `Error` has no class to recreate. Superagent builds its
  // message from `res.statusText || res.text`, and HTTP/2 carries no status
  // text, so without this the UI shows the raw JSON body.
  const bodyMessage = error?.response?.body?.message;
  if (error instanceof Error && typeof bodyMessage === "string") {
    error.message = bodyMessage;
  }
  return error;
}
